var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEvent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 7.5,
    r: 1.5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 6.5C8 6.22386 8.22386 6 8.5 6H19.5C19.7761 6 20 6.22386 20 6.5C20 6.77614 19.7761 7 19.5 7H8.5C8.22386 7 8 6.77614 8 6.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 8.5C8 8.22386 8.22386 8 8.5 8H14.5C14.7761 8 15 8.22386 15 8.5C15 8.77614 14.7761 9 14.5 9H8.5C8.22386 9 8 8.77614 8 8.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 12,
    r: 1.5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 11C8 10.7239 8.22386 10.5 8.5 10.5H16.5C16.7761 10.5 17 10.7239 17 11C17 11.2761 16.7761 11.5 16.5 11.5H8.5C8.22386 11.5 8 11.2761 8 11Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 13C8 12.7239 8.22386 12.5 8.5 12.5H15.5C15.7761 12.5 16 12.7239 16 13C16 13.2761 15.7761 13.5 15.5 13.5H8.5C8.22386 13.5 8 13.2761 8 13Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 16.5,
    r: 1.5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 15.5C8 15.2239 8.22386 15 8.5 15H18C18.2761 15 18.5 15.2239 18.5 15.5C18.5 15.7761 18.2761 16 18 16H8.5C8.22386 16 8 15.7761 8 15.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 17.5C8 17.2239 8.22386 17 8.5 17H12.5C12.7761 17 13 17.2239 13 17.5C13 17.7761 12.7761 18 12.5 18H8.5C8.22386 18 8 17.7761 8 17.5Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvent);
export default __webpack_public_path__ + "static/media/event.7bb84c61eb8e9c38cc8ebe6aa3eb1ef9.svg";
export { ForwardRef as ReactComponent };